"use client";

import Link from "next/link";
import { useState } from "react";
import { bookmarkKey, MAX_BOOKMARKS, type BookmarkKind } from "@/lib/bookmarks-shared";
import { toggleBookmark, useBookmarks } from "./store";
import "./bookmarks.css";

const Icon = ({ filled }: { filled: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round">
    <path d="M6 3.5h12v17l-6-4.2-6 4.2z" />
  </svg>
);

/** Merken-Knopf für Orte, Routen und Beiträge. Ohne JavaScript ausgeblendet. */
export function BookmarkButton({ kind, slug, title }: { kind: BookmarkKind; slug: string; title: string }) {
  const list = useBookmarks();
  const [msg, setMsg] = useState("");
  const saved = !!list?.some((b) => bookmarkKey(b) === bookmarkKey({ k: kind, s: slug }));
  const toggle = () => {
    const ok = toggleBookmark({ k: kind, s: slug, t: title });
    if (!ok) setMsg(saved ? "Konnte nicht gespeichert werden." : `Die Merkliste ist voll (höchstens ${MAX_BOOKMARKS} Einträge).`);
    else setMsg(saved ? "Von der Merkliste entfernt." : "Auf der Merkliste gespeichert.");
  };
  return (
    <span className="bm-wrap">
      <button type="button" className="bm-btn" aria-pressed={saved} onClick={toggle} disabled={list === null} hidden={list === null}>
        <Icon filled={saved} />
        {saved ? "Gemerkt" : "Merken"}
      </button>
      {saved && <Link className="bm-link" href="/merkliste">Zur Merkliste</Link>}
      <span className="sr-only" role="status">{msg}</span>
    </span>
  );
}

/** Link zur Merkliste im Header, mit Anzahl. */
export function BookmarkNavLink({ className }: { className?: string }) {
  const list = useBookmarks();
  const n = list?.length ?? 0;
  return (
    <Link className={className} href="/merkliste" aria-label={n ? `Merkliste, ${n} ${n === 1 ? "Eintrag" : "Einträge"}` : "Merkliste"}>
      <Icon filled={n > 0} />
      {n > 0 && <span className="bm-count" aria-hidden="true">{n > 99 ? "99+" : n}</span>}
    </Link>
  );
}
